// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__mu1n4","chevron":"Breadcrumb_chevron__L2+-h","backLink":"Breadcrumb_backLink__hRNxQ"};